module.exports = __webpack_public_path__ + "img/banner1.da2bc098.png";